export default __webpack_public_path__ + "media/images/pencil_v2-66b4ef488f01a56fb3276966ec5ff5c7.png";